import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MenuComponent } from './menu/menu.component';
import { FooterComponent } from './footer/footer.component';
import { RouterModule } from '@angular/router';
import { TransferHttpCacheModule } from '@nguniversal/common';
import { LoginCookie } from 'src/app/common/core/login-cookie';
import { ApiService } from 'src/app/common/api-service/api.service';
import { SendDataService } from 'src/app/common/api-service/send-data.service';
import { ELaboratorySurveyRoom } from './e-laboratory-survey-room';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ErrorInterceptor, JwtInterceptor } from 'src/app/common/_helpers';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

// import { SendDataService } from '../common/api-service/send-data.service';

@NgModule({
  declarations: [
    ELaboratorySurveyRoom,
    MenuComponent,
    FooterComponent,
  ],
  imports: [
    TransferHttpCacheModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule.forChild([
      {
        path: '', component: ELaboratorySurveyRoom, children: [
          {
            path: '',
            loadChildren: () => import('./content/content.module').then(m => m.ContentModule)
          },
        ],
      }
    ]),

  ],
  providers: [LoginCookie, ApiService, SendDataService,
    ],
})
export class ELaboratorySurveyRoomModule { }
